import { ModalForm } from 'framework/form';
import { Modal } from 'framework/ui/ui-builder';
import { useAuthenticationProvider } from 'infrastructure/security/authentication/AuthenticationProvider';
import useAssumptionsService from '../assumptionsService';
import { modalActionsSx } from '../shared/modalActionsSx';
import AssumptionForm from './AssumptionForm';
import { assumptionsValidation } from './assumptionsValidation';
import { ASSUMPTION_EXCEPTION_STATUS, AssumptionCreatePayload, AssumptionFormValues, AssumptionType } from '../types';

interface CreateAssumptionModalProps {
  projectId: string;
  isOpen: boolean;
  onClose: () => void;
  onSaved: (assumption: AssumptionType) => void;
}

const CreateAssumptionModal = ({ projectId, isOpen, onClose, onSaved }: CreateAssumptionModalProps) => {
  const { createAssumption } = useAssumptionsService();
  const { getUserAlias } = useAuthenticationProvider();

  return (
    <Modal isOpen={isOpen} onToggle={onClose} title="Add assumption">
      <ModalForm
        modalOpen={isOpen}
        closeModal={onClose}
        submitButtonText="Add assumption"
        actionsSx={modalActionsSx}
        submitFormFunc={async rawValues => {
          const values = rawValues as AssumptionFormValues;
          const alias = getUserAlias() ?? undefined;

          const payload: AssumptionCreatePayload = {
            projectId,
            description: values.description,
            assignedRole: values.assignedRole,
            status: values.status,
            createdBy: alias,
            ...(Boolean(values.requestException) && {
              exceptionStatus: ASSUMPTION_EXCEPTION_STATUS.PENDING,
              exceptionReason: values.exceptionReason,
              exceptionUntilDate: values.exceptionUntilDate,
            }),
          };
          return { result: await createAssumption(projectId, payload) };
        }}
        afterSubmit={{
          message: 'You are awesome! Assumption has been successfully created.',
          execute: (response: { result: AssumptionType }) => onSaved(response.result),
        }}
        getValidationSchemaFunc={() => Promise.resolve(assumptionsValidation)}
      >
        <AssumptionForm />
      </ModalForm>
    </Modal>
  );
};

export default CreateAssumptionModal;
